/* Variação relativa entre período atual e referência. */

/** (atual − referência) ÷ referência. Null quando não há base de comparação. */
export function relativeDelta(current: number, reference: number): number | null {
  if (reference === 0) return null;
  return (current - reference) / reference;
}
